# The MainView holds the wrapper template and is used to control rendering
# between the different child views.
app = require "app"
template = require "templates/main"
{ platform } = require("lib/device")

# Cache frequently used inbound/outbound containers, which are used
# when rendering new views
content = inbound = outbound = null

class MainView extends Backbone.View

  currentClass: "none"
  views: {}

  events: {
    "touchstart a[href*='//']": "openExternalUrl"
    "click a[href*='//']": "openExternalUrl"
    "touchstart a:not([href*='//'])": "openRelativeUrl"
    "click a:not([href*='//'])": "openRelativeUrl"
    "mouseleave": "triggerMouseUp"
    "touchmove": "onTouchMove"
  }

  # Add the html from the corresponding template and create the child views
  initialize: ->
    @el.innerHTML = template()

    # View rendering elements
    inbound = @el.querySelector("#inbound")
    outbound = @el.querySelector("#outbound")
    content = @el.querySelector("#content")

    @addGestures()

    @classForDeviceVersion()
    @onOrientationChange()

  classForDeviceVersion: ->
    @el.classList.add("device-#{platform.toLowerCase()}")

  # For external URLs, send an event for the parent application to navigate.
  openExternalUrl: (e) ->
    externalUrl = e.currentTarget.getAttribute("href")

    if window.ED_LMS_PREVIEW or window.ED_PUBLIC_PREVIEW
      window.parent.postMessage({
        type: "open-external-url",
        value: externalUrl
      }, "*")
    
    if window.ENGINE_PREVIEW
      window.open(externalUrl, "_blank")
      
    Application.publish("event:url-open")
      url: externalUrl
    return false

  # If a relative link contains a hash, follow the route as normal.
  # Ignore slide routes if the slide scroller is disabled.
  openRelativeUrl: (e) ->
    if e.currentTarget.hash
      window.setTimeout( =>
        unless e.currentTarget.hash.match(/slide/) and
               @currentView?.scroller?.enabled is false
          app.router.navigate(e.currentTarget.hash, true)
      , 1)

  display: (child, params) ->
    klass = "#{child}-active"

    if @currentClass is klass
      @currentView.display (->), params
    else
      @el.classList.remove "display", @currentClass
      @el.classList.add klass
      @currentClass = klass

      @transitionViews(child, params)

  # Create a new view based on the child view name and params passed. Avoid
  # this if its the same view has already been created, and enclass the main
  # view element for styling subview content.
  transitionViews: (child, params) ->
    View = require "./#{child}"
    done = (callback) => @afterDisplay(callback)

    @undelegateEvents()

    inbound.removeAttribute("id")
    outbound.removeAttribute("id")
    inbound.id = "outbound"
    outbound.id = "inbound"

    # Remove any listeners from the current view
    if @currentView?
      @currentView.stopListening()
      @currentView.undelegateEvents()
      @currentView.hide?()

    if @views[child] and @views[child].cid isnt @currentView.cid
      @currentView = @views[child]
      @currentView.display done, params
    else
      @currentView = new View params, done
      @currentView.el.classList.add("view")
      @currentView.undelegateEvents()
      @views[child] = @currentView unless @currentView.cache is false

    if params.preventScroll?
      @preventScroll = params.preventScroll
    if params.disableHistory?
      @currentView.disableHistory = params.disableHistory

    outbound.removeChild(outbound.lastChild) while (outbound.lastChild)
    outbound.appendChild @currentView.el

    window.addEventListener "orientationchange", =>
      @onOrientationChange()

  afterDisplay: (callback) ->
    window.clearTimeout @afterTimeout
    @afterTimeout = window.setTimeout (=>
      @el.classList.add("display")
      callback() if callback
      @afterTransition()
    ), 10

  # Remove oldView after transition
  afterTransition: ->
    window.clearTimeout @timeout
    @timeout = window.setTimeout( =>
      @currentView.delegateEvents()
      @delegateEvents()
      @swapContainers()
    , 600)

  swapContainers: ->
    _inb = outbound
    _otb = inbound
    inbound = _inb
    outbound = _otb
    outbound.removeChild(outbound.lastChild) while (outbound.lastChild)

  onOrientationChange: ->
    isPortrait =
      if window.orientation?
        window.orientation % 180 is 0
      else
        @el.offsetHeight > @el.offsetWidth

    @el.classList.toggle("device-landscape", not isPortrait)
    @el.classList.toggle("device-portrait",  isPortrait)

  triggerMouseUp: ->
    @$el.trigger("mouseup")

  onTouchMove: (e) ->
    scrollSelector =
      ".content-sm-scroll, .content-md-scroll, .content-lg-scroll"

    if @preventScroll and $(e.target).parents(scrollSelector).size() is 0
      e.preventDefault()

  addGestures: ->
    for evt in ["swipe", "gesture", "drag", "tap", "dbltap"]
      window.eventjs?.add @el, evt, (e, self) =>
        if self.gesture is "tap"
          if @ignoreNextTap
            @ignoreNextTap = false
          else
            @tapTimeout = window.setTimeout (=> @dispatchEvent(e, self)), 300
        else
          @ignoreNextTap = true if self.gesture is "dbltap"
          @dispatchEvent(e, self)

  dispatchEvent: (e, data) ->
    window.clearTimeout @tapTimeout

    if data.fingers > 1
      @preventDrag = true
    else if data.state is "down"
      @preventDrag = false

    if data.gesture is "drag" and @preventDrag
      return

    if e.target?
      @touchTarget = e.target

    evtName = "touch:#{data.gesture or data.type}"
    event = document.createEvent('CustomEvent')
    event.initCustomEvent(evtName, true, true, _.extend({}, e, data))

    @touchTarget.dispatchEvent event

module.exports = MainView
